import { render } from "./AssignResourceForm.vue?vue&type=template&id=ee538502&scoped=true&ts=true"
import script from "./AssignResourceForm.vue?vue&type=script&lang=ts"
export * from "./AssignResourceForm.vue?vue&type=script&lang=ts"

import "./AssignResourceForm.vue?vue&type=style&index=0&id=ee538502&scoped=true&lang=scss"
import "./AssignResourceForm.vue?vue&type=style&index=1&id=ee538502&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee538502"]])

export default __exports__